// SSP reducer to handle schema data enrichment

import { ICommonServerSideProps } from '@belong/common-nextjs-server-side-props';
import type { TSSPChain } from '@belong/ssp-execution';
import { Entry } from '@belong/types';
import { withoutParams } from '@belong/url-utils';
import { IPageData } from '../core/types';
import { getSchemaData } from '../helpers/getSchemaData';
import { TPublicSSPContext } from './types';
import type { GetServerSidePropsContext } from 'next';

export const SCHEMA_ENABLED_PAGES = ['/', '/internet', '/mobile', '/data-plans'];

const schemaDataEnrichment = (
  shouldHaveSchema: boolean,
  parsedPageEntry: Entry<any> | undefined,
  context: GetServerSidePropsContext,
  appServerSideProps: ICommonServerSideProps,
  pageProps: IPageData
): any => {
  return shouldHaveSchema ? getSchemaData(parsedPageEntry, context, appServerSideProps, pageProps) : undefined;
};

export const schemaDataSSP: TSSPChain<TPublicSSPContext> = async ctx => {
  const pageUrl = withoutParams(ctx.context.resolvedUrl);
  const schemaEnabled = SCHEMA_ENABLED_PAGES.includes(pageUrl);

  return {
    ...ctx,
    schemaData: schemaEnabled
      ? schemaDataEnrichment(schemaEnabled, ctx.pageEntry, ctx.context, ctx.appServerSideProps, ctx.pageProps)
      : undefined
  };
};
